export const SKILLS = {
  REACT: {
    name: "React",
    color: "bg-yellow-200",
    textColor: "text-yellow-800",
    darkBgColor: "dark:bg-yellow-600",
    darkTextColor: "dark:text-yellow-200",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1726791993/logo/react_sg628z.png",
  },
  NEXTJS: {
    name: "Next.js",
    color: "bg-zinc-200",
    textColor: "text-zinc-800",
    darkBgColor: "dark:bg-zinc-700",
    darkTextColor: "dark:text-zinc-100",
    logo: "https://cdn.worldvectorlogo.com/logos/next-js.svg",
  },
  REACT_NATIVE: {
    name: "React Native",
    color: "bg-pink-300",
    textColor: "text-pink-900",
    darkBgColor: "dark:bg-pink-700",
    darkTextColor: "dark:text-pink-100",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1726791993/logo/react_sg628z.png",
  },
  TYPESCRIPT: {
    name: "TypeScript",
    color: "bg-sky-300",
    textColor: "text-sky-900",
    darkBgColor: "dark:bg-sky-700",
    darkTextColor: "dark:text-sky-100",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1753687325/logo/typescript_bcsmhg.png",
  },
  JAVASCRIPT: {
    name: "JavaScript",
    color: "bg-blue-200",
    textColor: "text-blue-800",
    darkBgColor: "dark:bg-blue-600",
    darkTextColor: "dark:text-blue-200",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1726791971/logo/javascript_tlgwab.png",
  },
  TAILWIND: {
    name: "Tailwind CSS",
    color: "bg-purple-200",
    textColor: "text-purple-800",
    darkBgColor: "dark:bg-purple-600",
    darkTextColor: "dark:text-purple-200",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1726791985/logo/tailwind_b80pwy.png",
  },
  SHADCN: {
    name: "ShadCN UI",
    color: "bg-slate-200",
    textColor: "text-slate-800",
    darkBgColor: "dark:bg-slate-700",
    darkTextColor: "dark:text-slate-100",
    logo: "https://ui.shadcn.com/apple-touch-icon.png",
  },
  STYLED_COMPONENTS: {
    name: "Styled Components",
    color: "bg-fuchsia-300",
    textColor: "text-fuchsia-900",
    darkBgColor: "dark:bg-fuchsia-700",
    darkTextColor: "dark:text-fuchsia-100",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1753687529/logo/styled_components_fvhdp0.png",
  },
  EXPO: {
    name: "Expo",
    color: "bg-violet-300",
    textColor: "text-violet-900",
    darkBgColor: "dark:bg-violet-700",
    darkTextColor: "dark:text-violet-100",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1759425811/expo_hhahle.png",
  },
  HTML5: {
    name: "HTML5",
    color: "bg-green-200",
    textColor: "text-green-800",
    darkBgColor: "dark:bg-green-600",
    darkTextColor: "dark:text-green-200",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1726791975/logo/html_pe402c.png",
  },
  CSS3: {
    name: "CSS3",
    color: "bg-gray-200",
    textColor: "text-gray-800",
    darkBgColor: "dark:bg-gray-600",
    darkTextColor: "dark:text-gray-200",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1726791962/logo/css_ldx5n5.png",
  },
  GIT: {
    name: "Git & GitHub",
    color: "bg-teal-200",
    textColor: "text-teal-800",
    darkBgColor: "dark:bg-teal-600",
    darkTextColor: "dark:text-teal-200",
    logo: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1726791962/logo/git_iu7vmu.png",
  },
};

const skills = Object.values(SKILLS);

export default skills;